import { Component } from '@theme/component';
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

export class CartGiftPicker extends Component {
  chooseGift(event) {
    const button = event.currentTarget instanceof HTMLElement ? event.currentTarget : event.target;
    if (!(button instanceof HTMLElement) || button.hasAttribute('disabled')) return;

    const goldVariantId = button.dataset.goldVariantId;
    const silverVariantId = button.dataset.silverVariantId;
    if (!goldVariantId || !silverVariantId) return;

    const silverInput = document.getElementById('cart-gift-picker-silver');
    const isSilver = silverInput instanceof HTMLInputElement && silverInput.checked;
    const newVariantId = isSilver ? silverVariantId : goldVariantId;
    const previousVariantId = this.dataset.currentGiftVariantId || undefined;

    if (previousVariantId === newVariantId) return;

    this.#updateCart(newVariantId, previousVariantId, button);
  }

  removeGift(event) {
    const button = event.currentTarget instanceof HTMLElement ? event.currentTarget : event.target;
    if (!(button instanceof HTMLElement) || button.hasAttribute('disabled')) return;

    const previousVariantId = this.dataset.currentGiftVariantId || undefined;
    if (!previousVariantId) return;

    this.#updateCart(undefined, previousVariantId, button);
  }

  #updateCart(newVariantId, previousVariantId, button) {
    button.disabled = true;

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionIds = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) sectionIds.push(item.dataset.sectionId);
    });

    const updates = {};
    if (newVariantId) updates[newVariantId] = 1;
    if (previousVariantId && previousVariantId !== newVariantId) {
      updates[previousVariantId] = 0;
    }

    const deferredEventPromise = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'update',
        context: 'cart',
        lines: newVariantId
          ? [{ merchandiseId: newVariantId, quantity: 1 }]
          : [{ merchandiseId: previousVariantId, quantity: 0 }],
        promise: deferredEventPromise.promise,
      })
    );

    fetch(Theme.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates, sections: sectionIds.join(',') }),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          const message = response.message || response.description || 'Geschenk konnte nicht aktualisiert werden.';
          deferredEventPromise.reject(new Error(message));
          this.dispatchEvent(new CartErrorEvent({ error: message, code: 'INVALID' }));
          return;
        }

        deferredEventPromise.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(response),
          detail: {
            items: response.items,
            source: 'cart-gift-picker',
            sourceId: this.id || undefined,
            sections: response.sections,
            didError: false,
          },
        });
      })
      .catch((error) => {
        console.error(error);
        deferredEventPromise.reject(error);
        this.dispatchEvent(
          new CartErrorEvent({ error: error?.message || 'Network error while updating cart', code: 'SERVICE_UNAVAILABLE' })
        );
      })
      .finally(() => {
        button.disabled = false;
      });
  }
}

if (!customElements.get('cart-gift-picker')) {
  customElements.define('cart-gift-picker', CartGiftPicker);
}
